import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthDrawer } from '../context/AuthDrawerContext';
// Pricing hidden 2026-06-21 — re-enable when we charge again (restore this import + the two Pricing links below)
// import { isPromoActive } from './PromoBanner';

const NAV_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=Inter:wght@400;500;600;700&display=swap');

  @keyframes navGradShift { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }

  .topnav {
    position: sticky; top: 0; z-index: 100;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-bottom: 1px solid #f1f5f9;
    font-family: 'Inter', sans-serif;
  }
  .topnav-inner {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0.85rem 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
  }
  .topnav-brand {
    display: flex; align-items: center; gap: 0.55rem;
    text-decoration: none; color: #0f172a;
    margin-right: auto;
  }
  .topnav-logo {
    width: 34px; height: 34px; border-radius: 10px;
    background: linear-gradient(135deg,#6366f1,#ec4899);
    display: flex; align-items: center; justify-content: center;
    font-size: 0.95rem;
    box-shadow: 0 3px 12px rgba(99,102,241,0.3);
  }
  .topnav-wordmark {
    font-family: 'Syne', sans-serif;
    font-weight: 800;
    font-size: 1.15rem;
    letter-spacing: -0.03em;
    color: #0f172a;
  }
  .topnav-beta {
    padding: 0.15rem 0.5rem;
    background: linear-gradient(135deg,rgba(99,102,241,0.1),rgba(236,72,153,0.1));
    border: 1px solid rgba(99,102,241,0.3);
    border-radius: 999px;
    font-size: 0.55rem; font-weight: 700;
    color: #6366f1; letter-spacing: 0.06em;
    margin-left: 0.2rem;
  }

  .topnav-links {
    display: flex; align-items: center; gap: 1.75rem;
  }
  .topnav-link {
    text-decoration: none;
    color: #475569;
    font-size: 0.92rem;
    font-weight: 600;
    transition: color 0.15s;
  }
  .topnav-link:hover { color: #6366f1; }

  .topnav-actions {
    display: flex; align-items: center; gap: 0.75rem;
  }
  .topnav-signin {
    border: none; background: none; cursor: pointer;
    text-decoration: none;
    color: #475569;
    font-family: 'Inter', sans-serif;
    font-size: 0.92rem;
    font-weight: 600;
    padding: 0.55rem 0.9rem;
    border-radius: 10px;
    transition: all 0.15s;
  }
  .topnav-signin:hover { color: #0a0a0c; background: #f4f4f5; }

  .topnav-cta {
    border: none; cursor: pointer;
    text-decoration: none;
    color: white;
    font-family: 'Inter', sans-serif;
    font-size: 0.92rem;
    font-weight: 700;
    padding: 0.62rem 1.15rem;
    border-radius: 10px;
    background: #0a0a0c;
    transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
    white-space: nowrap;
  }
  .topnav-cta:hover { background: #18181b; transform: translateY(-1px); box-shadow: 0 8px 20px rgba(10,10,12,0.22); }

  .topnav-mobile-menu { display: none; }

  .topnav-burger {
    display: none;
    background: none; border: none; cursor: pointer;
    width: 36px; height: 36px;
    flex-direction: column; justify-content: center; align-items: center;
    gap: 5px;
  }
  .topnav-burger span {
    width: 20px; height: 2px; background: #0f172a; border-radius: 2px;
    transition: transform 0.2s, opacity 0.2s;
  }
  .topnav-burger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .topnav-burger.open span:nth-child(2) { opacity: 0; }
  .topnav-burger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  @media (max-width: 768px) {
    .topnav-inner { padding: 0.75rem 1.25rem; gap: 0.75rem; }
    .topnav-links, .topnav-actions { display: none; }
    .topnav-burger { display: flex; }

    .topnav.mobile-open .topnav-mobile-menu {
      display: flex;
    }
    .topnav-mobile-menu {
      display: none;
      flex-direction: column;
      padding: 0.5rem 1.25rem 1.25rem;
      border-top: 1px solid #f1f5f9;
      background: white;
      gap: 0.5rem;
    }
    .topnav-mobile-menu .topnav-link,
    .topnav-mobile-menu .topnav-signin {
      padding: 0.8rem 0.5rem;
      font-size: 1rem;
      text-align: left;
    }
    .topnav-mobile-menu .topnav-cta {
      margin-top: 0.5rem;
      text-align: center;
      padding: 0.9rem 1.1rem;
      font-size: 1rem;
    }
  }
`;

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { openSignIn, openSignUp } = useAuthDrawer();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const handleSignIn = () => { setOpen(false); openSignIn(); };
  const handleSignUp = () => { setOpen(false); openSignUp(); };

  return (
    <>
      <style>{NAV_CSS}</style>
      <nav className={`topnav${open ? ' mobile-open' : ''}`}>
        <div className="topnav-inner">
          <Link to="/" className="topnav-brand" aria-label="CreatorKhata home">
            <div className="topnav-logo">🎬</div>
            <span className="topnav-wordmark">CreatorKhata</span>
            <span className="topnav-beta">BETA</span>
          </Link>

          <div className="topnav-links">
            <a href="/#features" className="topnav-link">Features</a>
            {/* Pricing hidden 2026-06-21: {!isPromoActive() && <Link to="/pricing" className="topnav-link">Pricing</Link>} */}
            <a href="/blog" className="topnav-link">Blog</a>
            <Link to="/help" className="topnav-link">Help</Link>
            <Link to="/contact" className="topnav-link">Contact</Link>
          </div>

          <div className="topnav-actions">
            <button type="button" className="topnav-signin" onClick={handleSignIn}>
              Sign in
            </button>
            <button type="button" className="topnav-cta" onClick={handleSignUp}>
              Get started →
            </button>
          </div>

          <button
            className={`topnav-burger${open ? ' open' : ''}`}
            onClick={() => setOpen(o => !o)}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
          >
            <span /><span /><span />
          </button>
        </div>

        <div className="topnav-mobile-menu">
          <a href="/#features" className="topnav-link">Features</a>
          {/* Pricing hidden 2026-06-21: <Link to="/pricing" className="topnav-link">Pricing</Link> */}
          <a href="/blog" className="topnav-link">Blog</a>
          <Link to="/help" className="topnav-link">Help</Link>
          <Link to="/contact" className="topnav-link">Contact</Link>
          <button type="button" className="topnav-signin" onClick={handleSignIn}>
            Sign in
          </button>
          <button type="button" className="topnav-cta" onClick={handleSignUp}>
            Get started — no card needed →
          </button>
        </div>
      </nav>
    </>
  );
}
